import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Manejo de errores en el arranque de la aplicaciion
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
